import React from "react";
import { IonIcon } from "@ionic/react";
import { logoLinkedin, logoInstagram } from "ionicons/icons";
import "../static/css/Footer.css";

const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-content-header">
              <p>Services</p>
            </div>
            <div className="footer-content-content">
              <ul>
                <li>
                  <a href="https://quindl.com/services">Accelerate</a>
                </li>
                <li>
                  <a href="https://quindl.com/services">Assure</a>
                </li>
                <li>
                  <a href="https://quindl.com/services">
                    Data Engineering and Processing
                  </a>
                </li>
                <li>
                  <a href="https://quindl.com/services">Experience</a>
                </li>
                <li>
                  <a href="https://quindl.com/services">Innovate</a>
                </li>
                <li>
                  <a href="https://quindl.com/services">
                    Business Process Management
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-content">
            <div className="footer-content-header">
              <p>Social</p>
              <span>
                <a
                  href="https://www.linkedin.com/company/quindl-technologies"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <IonIcon icon={logoLinkedin} className="social" />
                </a>
                <a
                  href="https://www.instagram.com/quindltechnologies?igsh=MXE1Yjk4N3N3dTRpbQ=="
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <IonIcon icon={logoInstagram} className="social" />
                </a>
              </span>
            </div>
          </div>
          <div className="footer-content">
            <div className="footer-content-header">
              <p>Quick links</p>
            </div>
            <div className="footer-content-content1">
              <ul>
                <li>
                  <a href="https://quindl.com">Home</a>
                </li>
                <li>
                  <a href="https://quindl.com/aboutus">About</a>
                </li>
                <li>
                  <a href="https://quindl.com/contactus">Contact</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-content">
            <div className="footer-content-header">
              <p>Address</p>
            </div>
            <div className="footer-content-content">
              <p>
                38, Tatabad 3rd St, Hudco Colony, Tatabad, Coimbatore, Tamil
                Nadu 641012
              </p>
            </div>
            <div className="footer-content-header">
              <p>Mobile</p>
            </div>
            <div className="footer-content-content">
              <p>+91 9994916848</p>
            </div>
            <div className="footer-content-header">
              <p>Email</p>
            </div>
            <div className="footer-content-content">
              <p>info@quindl.com</p>
            </div>
          </div>
        </div>
        <div className="footer-container-1">
          <hr />
          <p>© 2024 Quindl Technologies Pvt Ltd.</p>
        </div>
      </div>
    </>
  );
};

export default Footer;
